<template>
  <div class="oravita">
    <h1>Oraviţa</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/orav_1kl.jpg" width="125" border="0" height="110" alt="Oraviţa / Oravitza: ältestes Theater in Rumänien"
        @click="callImageClick('Oraviţa / Oravitza: ältestes Theater in Rumänien', 'orav_1.jpg', $event)">
						<br>Oraviţa / Oravitza: ältestes Theater in Rumänien
      </div>
      <div class="foto">
        <img src="../assets/fotos/orav_2kl.jpg" width="125" border="0" height="110" alt="Oraviţa / Oravitza: ältestes Theater in Rumänien"
        @click="callImageClick('Oraviţa / Oravitza: ältestes Theater in Rumänien', 'orav_2.jpg', $event)">
						<br>Oraviţa / Oravitza: ältestes Theater in Rumänien
      </div>
      <div class="foto">
        <img src="../assets/fotos/orav_3kl.jpg" width="125" border="0" height="110" alt="Bahnhof Oraviţa / Oravitza: 
        Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951"
        @click="callImageClick('Bahnhof Oraviţa / Oravitza:  Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951', 
        'orav_3.jpg', $event)">
				<br>Bahnhof Oraviţa / Oravitza: Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951
        <br>Im Jahre 1951 wurden viele Banater entlang der Grenze zu Serbien  
        in die Steppe des Baragan deportiert. Für die Deutschen im Banat war 
        dies die zweite verlustreiche Deportation innerhalb weniger Jahre.
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>